import React from 'react'

const Contact = () => {
  return (
    <div id="Contact">
            <h2>Contact Me</h2>
            <div className="container-vsmall"> 
                
                    <a href="https://github.com/sibashis12" target="_blank" rel="noreferrer"><i className="fa-brands fa-github fa-2x"></i></a>
                
                
                    <a href="https://www.linkedin.com/in/sibashis12" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin fa-2x"></i></a>
                
                
                    <a href="https://www.youtube.com/@sibashis_12" target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube fa-2x"></i></a>
                
               
                    <a href="https://www.instagram.com/sibashis_12/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram fa-2x"></i></a>
                
                
                    <a href="https://codeforces.com/profile/sibashis_12" target="_blank" rel="noreferrer"><i class="fa-solid fa-chart-simple fa-flip-horizontal fa-2x"></i></a>
                
            </div>
        </div>
  )
}

export default Contact
